<script setup lang="ts">
import { computed } from 'vue'
import type { HTMLAttributes } from 'vue'
import { cn } from '../utils'

interface IBadgeProps {
  variant?: 'default' | 'secondary' | 'outline'
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<IBadgeProps>(), {
  variant: 'default',
})

const variantClass = computed(() => {
  switch (props.variant) {
    case 'secondary':
      return 'badge--secondary'
    case 'outline':
      return 'badge--outline'
    default:
      return 'badge--default'
  }
})
</script>

<template>
  <span :class="cn('badge', variantClass, props.class)">
    <slot />
  </span>
</template>

<style>
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: calc(var(--radius) * 0.5);
  padding: 0.125rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1;
  text-transform: uppercase;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.badge--default {
  background-color: hsl(var(--primary));
  color: hsl(var(--primary-contrast));
}

.badge--secondary {
  background-color: hsl(var(--muted));
  color: hsl(var(--muted-foreground));
}

.badge--outline {
  border: 1px solid hsl(var(--border));
  color: hsl(var(--foreground));
  background-color: transparent;
}
</style>
